import React, { createContext, useContext, useState, useEffect } from 'react';
import localPreferencesService from '@/core/preferences/local-preferences-service';

interface HeadlineViewContextType {
  headlineView: boolean;
  setHeadlineView: (value: boolean) => void;
}

const HeadlineViewContext = createContext<HeadlineViewContextType | undefined>(undefined);

export function HeadlineViewProvider({ children }: { children: React.ReactNode }) {
  const [headlineView, setHeadlineView] = useState(false);

  useEffect(() => {
    localPreferencesService.getLocalPreferences().then(localPreferences => {
      setHeadlineView(localPreferences.headlineView ?? false);
    });
  }, []);

  useEffect(() => {
    localPreferencesService.updateLocalPreferences(async localPreferences => {
      localPreferences.headlineView = headlineView;
      return localPreferences;
    });
  }, [headlineView]);

  return (
    <HeadlineViewContext.Provider value={{ headlineView, setHeadlineView }}>
      {children}
    </HeadlineViewContext.Provider>
  );
}

export function useGlobalHeadlineView() {
  const context = useContext(HeadlineViewContext);
  if (context === undefined) {
    return { headlineView: false, setHeadlineView: () => {} };
  }
  return context;
}
